<template>
	<div id="nav-bar">
		<div class="button" ref="buttons" style="width:1px;height:1px;position: absolute;"></div>
		<div class="reportHead animated className" v-if="!ishowAram"></div>
		<div class="reportLeft animated className" v-if="!ishowAram"></div>
		<div class="reportRight animated className" v-if="!ishowAram"></div>
		<div class="reportBottom animated className" v-if="!ishowAram"></div>
		<audio controls ref="audio" :muted="muted" webkit-playsinline="true" playsinline="true" class="aud" style="width:0px;height:0px">
			<source src="@/assets/img/warmPlay.wav" />
		</audio>
		
		<div class="name">
			<img :src="EnterpriseInfo.firmLogo" alt="">
			<span>{{ EnterpriseInfo.firmName }}</span>
		</div>
		<div class="alarm" ref="area">
			<span class="red" @click="checkAlarm('urgent')">紧急事件<i
					v-if="eventInfo.urgent != 0">{{ eventInfo.urgent }}</i></span>
			<span class="yell" @click="checkAlarm('hiddenDanger')">隐患事件<i
					v-if="eventInfo.hiddenDanger != 0">{{ eventInfo.hiddenDanger }}</i></span>
			<span class="blue" @click="checkAlarm('notice')">通知事件<i
					v-if="eventInfo.notice != 0">{{ eventInfo.notice }}</i></span>
		</div>
		<Alarm :IncidentClassificationClass="IncidentClassificationClass" v-if="alarmShow" @closed="closed"></Alarm>
	</div>
</template>

<script>

import Alarm from "./Alarm.vue";
import { EventCount,EventListPage } from "../../api/power";
export default {
	name: "NavBar",
	data() {
		return {
			IncidentClassificationClass: "",
			alarmShow: false,
			eventInfo: {},
			timerID:null,
			text:"",
			aramlist:{},
			flag:false,
			muted:false
		}
	},
	components: {
		Alarm
	},
	computed: {
		ishowAram(){
			return this.eventInfo.urgent!=undefined&&this.eventInfo.urgent == 0&&this.eventInfo.hiddenDanger == 0
		},
		EnterpriseInfo() {
			return this.$store.state.project.EnterpriseInfo
		},
		projectInfo() {
			return this.$store.state.project.projectInfo
		},
		updataProject() {
			return [this.$store.getters.areaId, this.$store.getters.projectId]
		}
	},
	watch: {
		updataProject(n, o) {
			document.title = "e博视-综合智慧能源管理平台"
			this.text = "e博视-综合智慧能源管理平台"
			clearTimeout(this.timerID);
			this.getEventList();
			this.getAramList()
		},
		'$store.state.project.AlarmEvent'(n, o) {
			if (n != o) {
				this.alarmShow = true
				this.IncidentClassificationClass = n.level
				this.getEventList();

				document.title = n.loopName?n.loopName:n.deviceName+"-"+n.eventName
				this.text = document.title
				this.newtext();
				this.eventAudio();
			}
		},
		ishowAram(n,o){
			if(!n){
				this.getAramList()
			}
		},
		"$store.getters.projectId"(n,o){
			if(n!=o){
				document.title = "e博视-综合智慧能源管理平台"
			}
		}
	},
	methods: {
		async getAramList(){
            let result = await EventListPage({
                projectId: this.$store.getters.projectId,
                page:1,
                size:1000,
                incidentClassificationClass:"urgent,hiddenDanger",
                solveFlag:0                                                                                                                                                                                                                                                                                                                                                                                                                                     
            });
            let data = result.data.data.eventList.records;
			if(data.length>0){
				this.aramlist = data[0];

				document.title = this.aramlist.loopName?this.aramlist.loopName:this.aramlist.deviceName+"-"+this.aramlist.eventName
				this.text = document.title
				this.newtext();
			}
        },
		closed() {
			this.alarmShow = false
		},
		checkAlarm(item) {
			this.alarmShow = true
			this.IncidentClassificationClass = item
		},
		async getEventList() {
			let result = await EventCount({
				projectId: this.$store.getters.projectId,
				solveFlag: 0
			});
			let data = result.data.data.eventNum.all
			this.eventInfo = data
		},
		closePopover(e) {
			let self = this;
			if (self.$refs.area && !self.$refs.area.contains(e.target)) {
				if (self.alarmShow == true) {
					self.alarmShow = false;
				}
			}
		},
		eventAudio() {
			let self = this
			let music1 = new Audio();
			music1 = require("@/assets/img/warmPlay.wav");
			this.$refs.audio.src = music1;
			// this.$refs.buttons.click();
			this.muted = true
			this.$refs.audio.play();
			setTimeout(function () {
				self.$refs.audio.pause();
				self.muted = false
			}, 15000)
		},
		newtext() {    
			// let text = document.title
			clearTimeout(this.timerID);  //每次调用函数之前都清空定时器;
			document.title = this.text.substring(1, this.text.length) + this.text.substring(0, 1); //substring()方法用于提取字符串中介于两个指定下标之间的字符;
			this.text = document.title.substring(0, this.text.length);
			let self = this
			this.timerID = setTimeout(function(){
				self.newtext()
			},400);
		}
	},
	mounted() {
		this.getEventList();
		this.getAramList();
		document.addEventListener("click", this.closePopover);
    
				// this.$refs.buttons.click =()=>{    
				// 	if(this.flag){        
				// 		audio.pause();     
				// 		this.flag = false         
				// 	}else{      
				// 		audio.play();          
				// 		this.flag = true         
				// 	}     
				// }     
	}
}
</script>

<style scoped lang="less">

.className {
	-webkit-animation: twinkling 1s infinite ease-in-out
}

.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both
}

@-webkit-keyframes twinkling {
	50% {
		opacity: 0.5;
	}

	100% {
		opacity: 1;
	}
}

@keyframes twinkling {
	50% {
		opacity: 0.5;
	}

	100% {
		opacity: 1;
	}
}


@keyframes myfirst {
	0% {
		opacity: 0.3;
	}

	100% {
		opacity: 1;
	}
}

.reportHead {
	width: 100%;
	height: 50px;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 22;
	background: linear-gradient(0deg, rgba(8, 22, 47, 0) 0%, rgba(255, 25, 25, 0.80) 100%);
	// animation: myfirst 5s linear infinite;
	// transition: all 5s  ;
}

.reportLeft {
	width: 50px;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 22;
	background: linear-gradient(270deg, rgba(8, 22, 47, 0) 0%, rgba(255, 25, 25, 0.80) 100%);
}

.reportRight {
	width: 50px;
	height: 100%;
	position: absolute;
	right: 0;
	top: 0;
	z-index: 22;
	background: linear-gradient(90deg, rgba(8, 22, 47, 0) 0%, rgba(255, 25, 25, 0.80) 100%);
}

.reportBottom {
	width: 100%;
	height: 50px;
	position: absolute;
	left: 0;
	bottom: 0;
	z-index: 22;
	background: linear-gradient(180deg, rgba(8, 22, 47, 0) 0%, rgba(255, 25, 25, 0.80) 100%);
}

#nav-bar {
	padding: 0 20rem;

	.name {
		float: left;
		line-height: 5.5vh;

		img {
			// width: 40rem;
			height: 40rem;
			vertical-align: middle
		}

		span {
			font-size: 24rem;
			font-weight: bold;
			vertical-align: middle;
			padding-left: 10rem;
		}
	}

	.alarm {
		float: right;
		line-height: 5.5vh;
		position: relative;
		z-index: 23;

		span {
			display: inline-block;
			border-radius: 2px;
			color: #fff;
			width: 80px;
			height: 32px;
			text-align: center;
			line-height: 32px;
			font-size: 14rem;
			margin-left: 20rem;
			position: relative;
			cursor: pointer;

			i {
				width: 32rem;
				height: 16rem;
				text-align: center;
				line-height: 16rem;
				background: #FD4238;
				border: 1px solid #FFFFFF;
				border-radius: 8rem;
				position: absolute;
				top: -6rem;
				right: -10rem;
				font-size: 12rem;

			}
		}

		.red {
			background: #FD4238;
		}

		.blue {
			background: #0D94FF;

			i {
				background: #0D94FF;
			}
		}

		.yell {
			background: #F6BD16;

			i {
				background: #F6BD16;
			}
		}
	}
}</style>